import { useForm } from 'react-hook-form';
import { translate } from 'react-switch-lang';
import { Button, FormGroup, Modal, ModalBody, ModalHeader } from 'reactstrap';
import SweetAlert from 'sweetalert2';

const EditDevise = (props) => {
  const { register, handleSubmit } = useForm();

  const onSubmit = async ({ name, code }) => {
    const currency = { name, code: code.toUpperCase() };
    const response = await props.updateDeviseById(props.devise.id, currency);

    const codeExist = props.devises.find((devise) => devise.code.toUpperCase() === code.toUpperCase());

    if (codeExist) {
      return SweetAlert.fire(props.t('error'), props.t('code_exist'), 'error');
    }

    if (response.status === 200) {
      const curr = response.data;

      props.setDeviseState((prevState) => {
        const newState = prevState.map((devise) => {
          if (devise.id === curr.id) {
            return curr;
          }
          return devise;
        });

        return newState;
      });

      props.setIsOpen(false);
    } else {
      SweetAlert.fire(props.t('error'), props.t('err'), 'error');
    }
  };

  const toggle = () => {
    props.setIsOpen(false);
  };

  return (
    <Modal isOpen={props.isOpen} toggle={toggle} centered>
      <ModalHeader>{props.t('edit_devise')}</ModalHeader>

      <ModalBody>
        {props.devise && (
          <form onSubmit={handleSubmit(onSubmit)} className="needs-validation">
            <FormGroup className="form-row">
              <label>{props.t('devise_name')}</label>
              <input
                type="text"
                className="form-control"
                {...register('name', { required: true })}
                defaultValue={props?.devise?.name}
              />
            </FormGroup>
            <FormGroup className="form-row">
              <label>{props.t('devise_code')}</label>
              <input
                style={{ textTransform: 'uppercase' }}
                type="text"
                className="form-control"
                maxLength={3}
                {...register('code', { required: true, maxLength: 3 })}
                defaultValue={props?.devise?.code}
              />
            </FormGroup>

            <Button outline color="success" className="float-right" type="submit">
              {props.t('update')}
            </Button>
            <Button style={{ marginRight: '10px' }} color="secondary" className="float-right" onClick={toggle}>
              {props.t('cancel')}
            </Button>
          </form>
        )}
      </ModalBody>
    </Modal>
  );
};

export default translate(EditDevise);
